import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer mt-5 button-black rounded-4 mx-3">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Elivated Iron.</Col>
            <Col md={6}>
              <div className="text-sm-right d-none d-sm-block text-end">
                Design & Develop <i className="mdi mdi-heart text-danger"></i>{" "}
                by PixarsArt
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
